"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SumerProxy__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "logic",
                type: "address",
            },
            {
                internalType: "address",
                name: "admin_",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        stateMutability: "payable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "previousAdmin",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newAdmin",
                type: "address",
            },
        ],
        name: "AdminChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "beacon",
                type: "address",
            },
        ],
        name: "BeaconUpgraded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "implementation",
                type: "address",
            },
        ],
        name: "Upgraded",
        type: "event",
    },
    {
        stateMutability: "payable",
        type: "fallback",
    },
    {
        inputs: [],
        name: "admin",
        outputs: [
            {
                internalType: "address",
                name: "admin_",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newAdmin",
                type: "address",
            },
        ],
        name: "changeAdmin",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "implementation",
        outputs: [
            {
                internalType: "address",
                name: "implementation_",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newImplementation",
                type: "address",
            },
        ],
        name: "upgradeTo",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newImplementation",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "upgradeToAndCall",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        stateMutability: "payable",
        type: "receive",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class SumerProxy__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    getDeployTransaction(logic, admin_, data, overrides) {
        return super.getDeployTransaction(logic, admin_, data, overrides || {});
    }
    deploy(logic, admin_, data, overrides) {
        return super.deploy(logic, admin_, data, overrides || {});
    }
    connect(runner) {
        return super.connect(runner);
    }
    static createInterface() {
        return new ethers_1.Interface(_abi);
    }
    static connect(address, runner) {
        return new ethers_1.Contract(address, _abi, runner);
    }
}
exports.SumerProxy__factory = SumerProxy__factory;
SumerProxy__factory.bytecode = _bytecode;
SumerProxy__factory.abi = _abi;
//# sourceMappingURL=SumerProxy__factory.js.map